export const phoneRegExp =
  /^\+?([0-9]{1,4})?[ ]?(\(?\d{1,4}\)?)[ ]?(\d{1,4})[ ]?(\d{1,4})[ ]?(\d{1,9})$/;

//NAME
export const NAME_REGEX = /^[a-zA-Z\s'-]+$/;

// export const NAME_COMPANY_REGEX = /^[A-Za-z][A-Za-z\d\s/-]*$/;
export const NAME_COMPANY_REGEX = /^[A-Za-z\d#][A-Za-z\d\s/#-]*$/;
// export const LETTERS_ONLY_NAME_COMPANY_REGEX = /^[A-Za-z\s\-_]{0,70}$/;
export const LETTERS_ONLY_NAME_COMPANY_REGEX = /^[A-Za-z\d\s\-_#]{0,70}$/;

// POSTCODES
export const AUS_POSTCODE_REGEX = /^\d{4}$/; // AUS
export const USA_POSTCODE_REGEX = /^\d{5}(-\d{4})?$/; // USA

// DRIVER LICENSE NUMBERS
export const AUS_LICENSE_REGEX = /^[A-Za-z0-9]{6,9}$/; // AUS
export const USA_LICENSE_REGEX = /^[A-Za-z0-9]{4,16}$/; // USA

// DRIVER LICENSE CARD NUMBERS
export const AUS_CARD_NUMBER_REGEX = /^[0-9]{6,10}$/; // AUS
export const USA_CARD_NUMBER_REGEX = /^[0-9]{4,12}$/; // USA

export const NZL_NZBN_NUMBER_REGEX = /^[0-9]{6,13}$/; // NZL

// PASSPORT NUMBER
export const AUS_PASSPORT_NUMBER = /^[A-Z]{1,2}\d{7}$/; // AUS
export const UKR_PASSPORT_NUMBER = /^[A-ZА-Я]{1,2}\d{6}$/; // UKR

// MEDICARE CARD NUMBER
export const AUS_MEDICARE_CARD_NUMBER = /^\d{4}[ /-]?\d{5}[ /-]?\d(?:[ /-]?\d)?$/; // AUS

// ACN & ABN
export const AUS_ACN = /^\d(?:\s?\d){8}$/; // AUS
export const AUS_ABN = /^\d(?:\s?\d){10}$/; // AUS

export const REGISTER_OFFICE_REGEX = /^[A-Za-z\d\s/-]+,\s*[A-Za-z\d\s/-]+$/;

export const SIX_DIGITS_WITH_SEPARATOR_REGEX = /^(\d[- ]?){6}$/gm;
export const NINE_DIGITS_WITH_SEPARATOR_REGEX = /^(\d[- ]?){8,9}$/gm;
export const ELEVEN_DIGITS_WITH_SEPARATOR_REGEX = /^(\d[- ]?){11}$/gm;
